import DisclaimerPage from "../components/pages/DisclaimerPage";
import CaseInputPage from "../components/pages/CaseInputPage";
import OTPPage from "../components/pages/OTPPage";
import FaceVerificationPage from "../components/pages/FaceVerificationPage";
import CardPossessionPage from "../components/pages/CardPossessionPage";
import CardDigitsPage from "../components/pages/CardDigitsPage";
import CardScanPage from "../components/pages/CardScanPage";
import PinQuestionPage from "../components/pages/PinQuestionPage";
import ThankYouPage from "../components/pages/ThankYouPage";

export const routes = {
  disclaimer: {
    path: "/",
    component: DisclaimerPage,
    accessLevel: 0
  },
  case: {
    path: "/case",
    component: CaseInputPage,
    accessLevel: 0
  },
  otp: {
    path: "/otp",
    component: OTPPage,
    accessLevel: 1
  },
  face: {
    path: "/face",
    component: FaceVerificationPage,
    accessLevel: 2
  },
  cardPossession: {
    path: "/card-possession",
    component: CardPossessionPage,
    accessLevel: 3
  },
  cardScan  : {
    path: "/card-scan",
    component: CardScanPage,
    accessLevel: 4
  },
  cardDigits: {
    path: "/card-digits",
    component: CardDigitsPage,
    accessLevel: 5
  },
  
  pinQuestion: {
    path: "/pin",
    component: PinQuestionPage,
    accessLevel: 6
  },
  thankYou: {
    path: "/thank-you",
    component: ThankYouPage,
    accessLevel: 7
  }
};